import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import useAffiliate from "../../Hooks/AffiliateContext";
import MaisAtacado from "../../Services/MaisAtacado/MaisAtacado";

import Popup from "../../components/Popup/Popup";
import HomeNPS from "./Components/HomeNPS/HomeNPS";
import BasePage from "../../components/BasePage/BasePage";
import SideMenu from "../../components/SideMenu/SideMenu";
import HomeInfoConteiner from "./Components/HomeInfoContainer/HomeInfoContainer";
import BannerProgramaAfiliados from "../../assets/images/HomeConteudos/BannerProgramaAfiliados.png"

import "./Home.css";

const Home = () => {
  const navigate = useNavigate();
  const [NPS, setNPS] = useState(null);
  const [isSent, setIsSent] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const { affiliate, acceptedNewContract } = useAffiliate();

  const handleSendNPS = (answer) => {
    MaisAtacado.post("v1/nps/answer", answer).then(() => {
      setIsSent(true);
    });
  };

  const handleCloseNPS = () => {
    setNPS(null);
    localStorage.setItem("userAnswered", true);
  };

  useEffect(() => {
    if (affiliate && !acceptedNewContract) setOpenModal(true)
    else setOpenModal(false)
  }, [affiliate, acceptedNewContract]);

  return (
    <BasePage>
      {NPS && !NPS?.Questions[0]?.Answer && (
        <HomeNPS
          nps={NPS}
          isSent={isSent}
          onSend={handleSendNPS}
          onClose={handleCloseNPS}
        />
      )}
      
      <Popup
        open={openModal}
        onClose={() => setOpenModal(false)}
        mainPopupStyle={{ width: window.innerWidth <= 1024 ? "90vw" : "30vw" }}
      >
        <div style={{ position: "relative", width: "100%" }} onClick={() => navigate('/Afiliado/meu-cadastro')}>
          <img
            src={BannerProgramaAfiliados}
            alt="Novo contrato"
            style={{ width: "100%", display: "block" }}
          />
          <button className="button__popup_home">ASSINE O NOVO CONTRATO</button>
        </div>
      </Popup> 

      <main data-testid="home" className="main__home--container">
        <SideMenu />
        <HomeInfoConteiner />
      </main>
    </BasePage>
  );
};

export default Home;
